/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_HInputs */

const en_funnel_ob_seg_h = /** @type {(inputs: Funnel_Ob_Seg_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you most want to listen to?`)
};

const es_funnel_ob_seg_h = /** @type {(inputs: Funnel_Ob_Seg_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es lo que más quieres escuchar?`)
};

/**
* | output |
* | --- |
* | "What do you most want to listen to?" |
*
* @param {Funnel_Ob_Seg_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_h = /** @type {((inputs?: Funnel_Ob_Seg_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_h(inputs)
	return en_funnel_ob_seg_h(inputs)
});